import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';

export interface Order {
  id: string;
  status: string;
  orderNumber?: string;
  total?: number;
  totalAmount?: number;
  createdAt?: string;
  items?: unknown[];
  [key: string]: unknown;
}

export interface Product {
  id: string;
  name: string;
  price?: number;
  description?: string;
  category?: string;
  inStock?: boolean;
  [key: string]: unknown;
}

export interface NewOrderItem {
  productId: string;
  quantity: number;
  [key: string]: unknown;
}

export interface NewOrder {
  items: NewOrderItem[];
  [key: string]: unknown;
}

export const customerPortalApi = createApi({
  reducerPath: 'customerPortalApi',
  baseQuery: createAuthBaseQuery(),
  tagTypes: ['CustomerPortal'],
  endpoints: (builder) => ({
    getOrders: builder.query<Order[], void>({
      query: () => 'orders',
      providesTags: ['CustomerPortal'],
    }),
    getProducts: builder.query<Product[], void>({
      query: () => 'products',
      providesTags: ['CustomerPortal'],
    }),
    createOrder: builder.mutation<Order, NewOrder>({
      query: (body) => ({ url: 'orders', method: 'POST', body }),
      invalidatesTags: ['CustomerPortal'],
    }),
    getOrderDetails: builder.query<Order, string>({
      query: (id) => `orders/${id}`,
      providesTags: ['CustomerPortal'],
    }),
    updateOrderStatus: builder.mutation<Order, { id: string; status: string }>({
      query: ({ id, status }) => ({
        url: `orders/${id}`,
        method: 'PUT',
        body: { status },
      }),
      invalidatesTags: ['CustomerPortal'],
    }),
  }),
});

export const {
  useGetOrdersQuery,
  useGetProductsQuery,
  useCreateOrderMutation,
  useGetOrderDetailsQuery,
  useUpdateOrderStatusMutation,
} = customerPortalApi;
